export default __webpack_public_path__ + "static/media/dropbox-marked.d4a2d143.png";